import { render, staticRenderFns } from "./MicroLink.vue?vue&type=template&id=5f0b9e33&scoped=true&"
import script from "./MicroLink.vue?vue&type=script&lang=js&"
export * from "./MicroLink.vue?vue&type=script&lang=js&"
import style0 from "./MicroLink.vue?vue&type=style&index=0&id=5f0b9e33&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b9e33",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VIcon,VList,VMenu})
